module.exports = __webpack_public_path__ + "img/hr-green-pita-06.b55fa567.png";